import { FC } from 'react';

import { IconEndUser } from '@purpur/library/icon/end-user';
import { IconPeople } from '@purpur/library/icon/people';

import { AuthorFallbackImage, AuthorImage, AuthorName, BadgeLink, StyledAuthorBadge } from './AuthorBadge.styles';

type Props = {
    image?: string;
    description?: string;
    name?: string;
    isMultipleAuthors?: boolean;
    url?: string;
};

export const AuthorBadge: FC<Props> = ({ image, description, name, isMultipleAuthors, url }) => {
    const nameContent = (
        <AuthorName>
            <div>{name}</div>
        </AuthorName>
    );

    return (
        <StyledAuthorBadge>
            {image ? (
                <AuthorImage>
                    <img src={image} alt={description} />
                </AuthorImage>
            ) : (
                <AuthorFallbackImage aria-hidden={true}>
                    {isMultipleAuthors ? <IconPeople size="xs" /> : <IconEndUser size="xs" />}
                </AuthorFallbackImage>
            )}

            {url ? <BadgeLink href={url}>{nameContent}</BadgeLink> : nameContent}
        </StyledAuthorBadge>
    );
};
